import { premiumColors } from '../helpers'

export const useSubscription = (user?: wowaudit.User) => {
  const subscription = user?.subscription
  const declined = !!user?.linkedAccounts?.filter(
    (a) =>
      a.displayType === 'Patreon' && a.details?.status === 'declined_patron',
  ).length

  const legacySubscription = user?.linkedAccounts?.find(
    (a) =>
      a.displayType === 'Patreon' &&
      a.details?.active &&
      a.details.pledge_tier !== 'Free',
  )

  const subscriptionActive =
    (subscription?.active && !!subscription.tierName) ||
    !!legacySubscription?.details?.pledge_tier

  const subscriptionColor =
    premiumColors[
      subscription?.tierName ||
        legacySubscription?.details?.pledge_tier ||
        'Free'
    ]

  const subscriptionName =
    (subscription?.active
      ? subscription.tierName
      : legacySubscription?.details?.pledge_tier) || 'Free'

  return {
    declined,
    subscription,
    legacySubscription,
    subscriptionActive,
    subscriptionName,
    subscriptionColor,
  }
}
